module.exports = __webpack_public_path__ + "img/product.1ef68800.png";